module.exports = __webpack_public_path__ + "static/the-little-prince-d4ce0a91646427f63fe1f4c3c44b117d.jpg";